import React from "react";

const Footer = () => {
    return (
        <div className="footer">
            <p> Written in React JS and CSS</p>
        </div>
    );
};

export default Footer;
